  <template>
      <div class="control-section">
      <div  class="h100vh-140">
        <ejs-grid ref='grid' :dataSource="data" height='calc(100% - 0px)' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='66' textAlign='Center' minWidth='10px'></e-column>
            <e-column field='pvi' :headerText='$t("Pvi.pvi")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='ki' :headerText='$t("Pvi.ki")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='op' :headerText='$t("Pvi.op")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='amf' :headerText='$t("Pvi.amf")'  textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='qryPvi()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <CustomDialog ref='addPviPage' :element='dialog.element.eleAddPvi' :styles='dialog.styles' :messages='dialog.messages.addPvi'>
        <template v-slot:dialog-content>
          <AddPviForm ref="addPvi" ></AddPviForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='addBatchPviPage' :element='dialog.element.eleAddBatchPvi' :styles='dialog.styles' :messages='dialog.messages.addBatchPvi'>
        <template v-slot:dialog-content>
          <AddBatchPviForm ref="addBatchPvi" ></AddBatchPviForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='modPviPage' :element='dialog.element.eleModPvi' :styles='dialog.styles' :messages='dialog.messages.modPvi'>
        <template v-slot:dialog-content>
          <ModPviForm ref="modPvi" ></ModPviForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='puiListByPviPage' :element='dialog.element.eleQryPui' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <PviList ref='puiListByPvi'></PviList>
        </template>
      </CustomDialog>
      <DialogConfirm ref='dialogConfirm' :title='$t("LteUser.inquiry")' :content='$t("LteUser.delConfirm")' :onOk='onClickDelOk' ></DialogConfirm>
      <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
    </div>
  </template>
<script>
import { Reorder, Resize } from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../../common/CustomDialog";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddPviForm from "./dialog/AddPviForm";
import AddBatchPviForm from "./dialog/AddBatchPviForm";
import ModPviForm from "./dialog/ModPviForm";
import ajaxUrl from "../../data/ajaxUrl";
import { EventBus } from "../../../../plugins/eventBus";
import PviList from "./dialog/QryPviDialog";

export default {
  name: "PviTable",
  components: {
    CustomDialog,
    DialogConfirm,
    AddPviForm,
    AddBatchPviForm,
    ModPviForm,
    DialogList,
    PviList
  },
  data() {
    return {
      data: {},
      filterFlag: false,
      imsiFilter: "",
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0
      },
      ne: {
        neid: "",
        netype: "",
        neversion: ""
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: "810px",
          height: "760px",
          visible: false,
          model: true
        },
        stylesDelRange: {
          width: "810px",
          height: "auto",
          visible: false,
          model: true
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddPvi: {
            target: this.$refs.addPvi,
            refName: "eleAddPvi",
            buttonGroup: [
              {
                click: this.saveAddPvi,
                buttonModel: {
                  content: this.$t("LteUser.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.closeAddPviPage,
                buttonModel: { content: this.$t("LteUser.cancel") }
              }
            ],
            title: this.$t("Pvi.addPvi"),
            isClose: true
          },
          eleAddBatchPvi: {
            target: this.$refs.addBatchPvi,
            refName: "eleAddBatchPvi",
            buttonGroup: [
              {
                click: this.saveAddBatchPvi,
                buttonModel: {
                  content: this.$t("LteUser.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.closeAddBatchPviPage,
                buttonModel: { content: this.$t("LteUser.cancel") }
              }
            ],
            title: this.$t("Pvi.addBatchPvi"),
            isClose: true
          },
          eleModPvi: {
            target: this.$refs.modPvi,
            refName: "eleModPvi",
            buttonGroup: [
              {
                click: this.saveModPvi,
                buttonModel: {
                  content: this.$t("LteUser.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.closeModPviPage,
                buttonModel: { content: this.$t("LteUser.cancel") }
              }
            ],
            title: this.$t("Pvi.modPvi"),
            isClose: true
          },
          eleQryPui: {
            target: this.$refs.puiList,
            refName: "eleQryPui",
            buttonGroup: [
              {
                click: this.closeQryPuiList,
                buttonModel: { content: this.$t("MCS.cancle") }
              }
            ],
            title: this.$t("Pui.puiList"),
            isClose: true
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: "dialogList",
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("LteUser.confirm") }
              }
            ],
            title: this.$t("LteUser.logger"),
            isClose: true
          }
        },
        messages: {
          addPvi: {
            title: this.$t("Pvi.addPvi")
          },
          addBatchPvi: {
            title: this.$t("Pvi.addBatchPvi")
          },
          modPvi: {
            title: this.$t("Pvi.modPvi")
          }
        }
      },
      position: { X: "Center", Y: "Top" },
      descCommonError: {
        0: this.$t("DNN.commonError0"),
        1: this.$t("DNN.commonError1"),
        2: this.$t("DNN.commonError2"),
        3: this.$t("DNN.commonError3"),
        4: this.$t("DNN.commonError4"),
        5: this.$t("DNN.commonError5"),
        6: this.$t("DNN.commonError6"),
        7: this.$t("DNN.commonError7"),
        8: this.$t("DNN.commonError8"),
        9: this.$t("DNN.commonError9"),
        10: this.$t("DNN.commonError10"),
        11: this.$t("DNN.commonError11"),
        12: this.$t("DNN.commonError12"),
        13: this.$t("DNN.commonError13"),
        14: this.$t("DNN.commonError14"),
        15: this.$t("DNN.commonError15")
      }
    };
  },
  provide: {
    grid: [Reorder, Resize]
  },
  methods: {
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryPvi();
    },
    isChooseNe() {
      if (this.ne.neid === "") {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("LteUser.pleaseSelectNE")
        });
        return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("PDN.pleaseSelectDatas")
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("PDN.pleaseSelectOneData")
        });
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const userId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        userId.push(checkedData[i].pvi);
      }
      return userId.length === 0 ? false : userId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      console.log("response",response)
      if (0 !== response.data.resultVal.result) {
        EventBus.$emit("toast", {
          type: "warning",
          // content: this.$t("DNN.commonError" + response.data.resultVal.result)
          content: response.data.errorString
        });
        return true;
      }
      return false;
    },
    openAddPviPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addPvi.getJson(this.ne, response => {
        if (response.data.errorCode !== "0") {
          EventBus.$emit("toast", {
            type: "warning",
            content: response.data.errorString
          });
          return;
        }
        this.$refs.addPviPage.show();
      });
    },
    closeAddPviPage() {
      this.$refs.addPviPage.clear();
      this.$refs.addPviPage.close();
    },
    saveAddPvi() {
      this.$refs.addPvi.saveUser(this.ne, response => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddPviPage();
        EventBus.$emit("toast", {
          type: "success",
          content: this.$t("Pvi.addPviSuccess")
        });
        this.qryPvi();
      });
    },
    getKey(obj, value) {
      for (let key in obj) {
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
    openModPviPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
        const record = checkedDatas.map(item => {
          return {
            ...item
          };
        });
        this.$refs.modPvi.getJson(this.ne, record, response => {
          if (response.data.errorCode !== "0") {
            EventBus.$emit("toast", {
              type: "warning",
              content: response.data.errorString
            });
            return;
          }
          this.$refs.modPviPage.show();
        });
      }
    },
    closeModPviPage() {
      this.$refs.modPviPage.clear();
      this.$refs.modPviPage.close();
    },
    saveModPvi() {
      this.$refs.modPvi.saveUser(this.ne, response => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeModPviPage();
        EventBus.$emit("toast", {
          type: "success",
          content: this.$t("Pvi.modPviSuccess")
        });
        this.qryPvi();
      });
    },
    /**
     * 打开/关闭/保存  pui列表页面
     */
    openQryPuiByPviPage() {
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas.length !== 0) {
        const record = checkedDatas.map(item => {
          return {
            ...item
          };
        });
        this.$refs.puiListByPvi.getPuiListByPvi(record, this.ne.neid);
        this.$refs.puiListByPviPage.show();
      }
    },
    closeQryPuiList() {
      this.$refs.puiListByPviPage.clear();
      this.$refs.puiListByPviPage.close();
    },
    delUsers() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      console.log("delKeys", delKeys);
      const params = {
        vo: {
          pviList: delKeys
        },
        info: {
          msgid: "30475",
          neid: this.ne.neid
        }
      };

      this.$axios.post(ajaxUrl.delCommonD, params).then(response => {
        if (!response) {
          console.log("onClickDelOk response error");
          return;
        }
        if (!response.data) {
          console.log("onClickDelOk response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("onClickDelOk response.data.resultVal null error");
          return;
        }
        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < delKeys.length; i++) {
          operList.push({
            operObj: delKeys[i],
            operResult: resultCodeStr[i],
            operCode: resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delKeys.length);
        this.$refs.dialogListPage.show();
        this.qryPvi(undefined, undefined, true);
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    refreshData() {
      this.imsiFilter = "";
      this.filterFlag = false;
      this.qryPvi(0, true);
    },
    filterData() {
      this.filterFlag = true;
      this.qryPvi(1, true);
    },
    qryPvi(flag = undefined, prompt = false, delFlag = false) {
      if (this.isChooseNe() === false) {
        return;
      }
      this.page.pageNo = this.filterFlag
        ? 1
        : this.$refs.pager.ej2Instances.currentPage;
      if (delFlag) {
        this.page.pageNo = 1;
      }
      this.filterFlag = false;

      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      let params = {
        vo: {
          flag: 0
        },
        info: {
          msgid: "30476",
          neid: this.ne.neid
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize
        }
      };

      if (flag === 1) {
        //1是单独查询
        if (this.imsiFilter == "") {//查询的是空则相当于刷新
          this.refreshData();
        } else {
          params = {
            vo: {
              pvi: this.imsiFilter
            },
            info: {
              msgid: "30473",
              neid: this.ne.neid
            },
            page: {
              pageNo: this.page.pageNo,
              pageSize: this.page.pageSize
            }
          };
        }
      }

      this.$axios.post(ajaxUrl.requestCommonD, params).then(response => {
        //真数据
        console.log("qryPvi response", response);
        if (!response) {
          console.log("qryPvi response error");
          return;
        }
        if (!response.data) {
          console.log("qryPvi response.data error");
          return;
        }
        if (response.data.errorCode === "subscriber.9005") {
          this.ne.neid = "";
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("MCS.neOffLine")
          });
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryPvi response.data.resultVal error");
          return;
        }
        if (
          response.data.resultVal.result !== 0 &&
          response.data.resultVal.result !== 1
        ) {
          console.log("qryPvi response.data.resultVal.result error");
          return;
        }
        const res = response.data.resultVal; //todo 假数据
        if (res) {
          if (res.pviInfo) {
            const pviInfo = res.pviInfo.map(item => {
              return {
                ...item
              };
            });
            this.data = pviInfo;
          } else {
            this.data = [];
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countRsp;
          this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }
      });
    },
    openAddBatchPviPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addBatchPvi.getJson(this.ne, response => {
        if (response.data.errorCode !== "0") {
          EventBus.$emit("toast", {
            type: "warning",
            content: response.data.errorString
          });
          return;
        }
        this.$refs.addBatchPviPage.show();
      });
    },
    closeAddBatchPviPage() {
      this.$refs.addBatchPviPage.clear();
      this.$refs.addBatchPviPage.close();
    },
    saveAddBatchPvi() {
      this.$loading.showLoadding(
        this.$t("Pvi.addBatchPvi"),
        this.$t("SubscriberIms.waitTip")
      );
      this.$refs.addBatchPvi.saveBatchUser(this.ne, (response, addPviList) => {
        if (this.responseIsFailed(response)) {
          this.$loading.hideLoadding();
          return;
        }
        this.closeAddBatchPviPage();
        this.$loading.hideLoadding();

        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < addPviList.length; i++) {
          operList.push({
            operObj: addPviList[i].pvi,
            operResult: resultCodeStr[i],
            operCode: resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(addPviList.length);
        this.$refs.dialogListPage.show();
        this.qryPvi();
      });
    },
    setfilter(params) {
      this.imsiFilter = params;
    }
  }
};
</script>

<style scoped>
</style>
